import { DateTime } from "luxon";
import { useSelectedTimeStore } from "./useSelectedTimeStore";
import { useEffect, useMemo, useState } from "react";
import { debounce } from "@shared/common/utils/timing";

export function useDebouncedSelectedTime(debounceTimeInMs: number): DateTime | undefined {
  const [debouncedSelectedTime, setInnerSelectedTime] = useState<DateTime | undefined>(
    useSelectedTimeStore.getState().selectedTime,
  );
  const setDebouncedSelectedTime = useMemo(
    () => debounce(debounceTimeInMs, setInnerSelectedTime),
    [debounceTimeInMs],
  );

  useEffect(
    () => useSelectedTimeStore.subscribe((state) => setDebouncedSelectedTime(state.selectedTime)),
    [setDebouncedSelectedTime],
  );
  return debouncedSelectedTime;
}
